import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import ProductlaneWidget from "../components/ProductlaneWidget";
import AppProvider from "../contexts/AppContext";

const AdminLayout = () => {
  return (
    <AppProvider>
      <div className="w-full min-h-screen flex bg-background">
        <Sidebar />
        <div className="w-full overflow-x-auto md:overflow-hidden relative">
          <Navbar />
          <Outlet />
        </div>
      </div>
      <ProductlaneWidget />
    </AppProvider>
  );
};

export default AdminLayout;
